import { Organization } from 'torqcloud-ui'

export function canViewOrganizationAuditLog(organization?: Pick<Organization, 'permissions'> | null) {
  if (!organization) {
    return false
  }

  return organization.permissions?.view_organization_audit_log === true
}
